import templateUrl from './avatar.html';
import './avatar.less';

export default angular
    .module('eventix.common.directives.avatar', [])
    /**
     * @ngdoc directive
     * @name eventix.common.directives:avatar
     * @restrict element
     * @description
     * An avatar for a model. A colored background circle which chooses the same color every time depending on the
     * specified model's guid. The first character of the specified model's name is used inside the circle.
     *
     * @param {String} ngModel The container of which the name and guid are used
     * @param {String} selected attribute which signifies the state of the avatar (eg: selected or not)
     *
     * @example
     * ```
     * <avatar ng-model="$ctrl.company" selected="$ctrl.companyIsSelected"></avatar>
     * ```
     *
     * @example
     * ```
     * <avatar ng-model="$ctrl.company" selected="$ctrl.companyIsSelected">
     *     <avatar ng-model="$ctrl.user"></avatar>
     * </avatar>
     * ```
     */
    .component('avatar', {
        bindings: {
            selected: '<'
        },
        require: {
            ngModel: 'ngModel'
        },
        transclude: true,
        templateUrl: templateUrl,
        controller: AvatarController
    }).name;

function AvatarController($scope, $element, $attrs, $q) {
    const $ctrl = this;

    $ctrl.$onInit = function() {
        init();
    };

    $scope.$watch('$ctrl.ngModel.$modelValue', (model) => {
        $ctrl.model = model;

        init();
    });

    function init() {
        let id = _.get($ctrl.model, 'guid', _.get($ctrl.model, 'id', 'unknown'));
        let name = _.get($ctrl.model, 'name', _.get($ctrl.model, 'label', '?'));

        if (name === '')
            name = '?';

        $ctrl.color = strToColor(id);
        $ctrl.character = name.charAt(0);
        $ctrl.colorContrast = colorNeedsContrast($ctrl.color);
    }

    function strToColor(str) {
        let i, hash = 0;

        for (i = 0; i < str.length; i++)
            hash = str.charCodeAt(i) + ((hash << 5) - hash);

        let color = '#';

        for (i = 0; i < 3; i++) {
            let value = ((hash >> (i * 8)) + 128) & 0xFF;

            color += ('00' + value.toString(16)).substr(-2);
        }

        return color;
    }

    function colorNeedsContrast(color) {
        // Algorithm from https://www.w3.org/TR/AERT/#color-contrast
        if (color.length !== 7)
            return false;

        let rgb = [
            color.slice(1, 3),
            color.slice(3, 5),
            color.slice(5, 7)
        ];

        let o = Math.round(((parseInt(rgb[0], 16) * 299) + (parseInt(rgb[1], 16) * 587) + (parseInt(rgb[2], 16) * 114)) / 1000);

        return o <= 125;
    }
}
